import type { FC } from 'react'
import type { ICmsHero } from '@/pages/tad.ai/_components/FeatureCms/_types'

import { H1 } from '@/pages/tad.ai/_components/H1'
import { PrimaryButton } from '@/pages/tad.ai/_components/PrimaryButton'
import { RichTextElement } from '@/pages/tad.ai/_components/RichTextElement/RichTextElement'
import { paddingHeaderHeightCls } from '@/pages/tad.ai/_layout/Header/constants'

import { cls } from 'tagged-classnames-free';
export interface IHeroProps {
  hero?: ICmsHero | null
  className?: string
}

export const Hero: FC<IHeroProps> = (props) => {
  const { hero, className } = props || {}
  if (!hero) {
    return null
  }
  const { h1, h1Desc, btnHref, btnText } = hero

  return (
    <div
      className={cls`mx-auto max-w-[900px] text-center ${paddingHeaderHeightCls} ${className}`}
    >
      <H1 className='font-normal'>{h1}</H1>
      <RichTextElement
        as='p'
        html={h1Desc}
        className='text-f-other-10 [&_a]:text-f-primary pt-3 text-sm md:pt-4 md:text-base [&_a]:hover:underline'
      />
      {btnHref && btnText && (
        <PrimaryButton href={btnHref} className='mx-auto mt-6 md:mt-12'>
          {btnText}
        </PrimaryButton>
      )}
    </div>
  )
}
